export enum PermissionBaseType {
  PERMISSION = 0,
  FLAG,
}
